import axios from './axiosConfig'

export type DeliveryZoneRow = {
 id: string
 branch_id: string
 name: string
 delivery_fee: string | number
 is_active?: boolean
 sort_order?: number
 notes?: string | null
 branch?: { id: string; name?: string } | null
}

export type DeliveryZonePayload = {
 branch_id: string
 name: string
 delivery_fee: number
 is_active?: boolean
 sort_order?: number
 notes?: string | null
}

export interface DeliveryZoneListParams {
 branch_id?: string
 search?: string
 is_active?: boolean | string
 sort_by?: string
 sort_dir?: 'asc' | 'desc'
 per_page?: number
 page?: number
}

export const deliveryZonesAPI = {
 getAll: async (params?: DeliveryZoneListParams | Record<string, unknown>) => {
 const response = await axios.get('/delivery-zones', { params })
 return response.data
 },

 getActive: async (params?: { branch_id?: string }) => {
 const response = await axios.get('/delivery-zones/active', { params })
 return response.data
 },

 create: async (data: DeliveryZonePayload) => {
 const response = await axios.post('/delivery-zones', data)
 return response.data
 },

 update: async (id: string, data: DeliveryZonePayload) => {
 const response = await axios.put(`/delivery-zones/${id}`, data)
 return response.data
 },

 delete: async (id: string) => {
 const response = await axios.delete(`/delivery-zones/${id}`)
 return response.data
 },
}

